import React from 'react';
import { SearchEmployee, SearchResults, SelectedEmployee } from '@components/molecules';

const EmployeeSearchBar = ({ 
    filteredData, 
    setFilteredData, 
    loading, 
    setLoading, 
    noResults, 
    setNoResults, 
    employeeSelected, 
    setEmployeeSelected, 
    employeeData, 
    handleOnClick
}) => {
    
    return (
        <>
            <SearchEmployee 
                filteredData={filteredData} 
                setFilteredData={setFilteredData}
                loading={loading}
                setLoading={setLoading}
                setNoResults={setNoResults}
                setEmployeeSelected={setEmployeeSelected}
            />

              {employeeSelected ? 
                <SelectedEmployee employeeData={employeeData} /> :
                <SearchResults 
                  filteredData={filteredData} 
                  noResults={noResults} 
                  handleOnClick={handleOnClick}
                />
              }
        </>
    )
}

export default EmployeeSearchBar;
